export default {
  aidc: {
    data: require('@/assets/images/aidc/01.gif'),
    data2: require('@/assets/images/aidc/his_cn.gif'),
    data3: require('@/assets/images/aidc/reset_cn.gif'),
    data4: require('@/assets/images/aidc/ability_cn.gif'),
    data5: require('@/assets/images/aidc/primes.gif'),
    data6: require('@/assets/images/aidc/desi.gif'),
    context: {
      title: 'AI基础设施全栈技术服务商 - AIDC 全栈解决方案',
      introduction: '业务简介:',
      introduction_text:
        '亚太领先的AI算力基础设施全栈技术服务商，为客户提供AIDC一体化交付运营服务与算力集群全栈服务。',
      operations: '01 AIDC一体化交付及运营',
      operations_text0:
        ' 覆盖从规划设计、建设交付及运营管理的全生命周期运营服务，为客户提供AIDC一体化交付运营解决方案。',
      operations_text1: `业务足迹:已建成建筑面积约100万平方米，已建成超500MWIDC。项目足迹:国内(上海、广东深圳，安徽芜湖)与海外(日本大阪、马来柔佛、泰国 曼谷等);规划至2030年，交付总建筑面积超150万平方米，总MW规划超1.5GW。`,

      case: '交付案例',
      projectCase: {
        shanghai: '上海',
        sz: '深圳',
        wuhu: '安徽芜湖',
        shanghaiDesc: [
          '建筑规模: 8栋数据中心',
          'IT总产出: 300+MW',
          '配有3*200MVA 220kV市政电源供电',
        ],
        szDesc: [
          '建筑规模: 3栋集群、1.2万机柜',
          'IT总产出: 90+ MW',
          '配有3*200MVA 220kV市政电源供电',
        ],
        wuhuDesc: [
          '用地规模: 总建筑面积41万平方米',
          '建筑规模: 1栋220kV 变配电站、1栋综合管理楼、8栋数据中心楼',
          'IT总产出: 300+ MW',
        ],
      },
      Maintenance: '02 算力集群部署与运维',
      Maintenance_text0: ` 提供覆盖从规划设计，算力部署交付到智能运维的全生命周期解决方案。`,
      Maintenance_text1: ` 业务足迹:项目遍布东南亚、并在日本、北美有丰富私有化部署案例，已累计交付及服务算力超40万P，运维T总负载超300MW，已完成部署超10个万卡 集群。`,

      server: `AIDC技术服务能力`,
      server_text: ` 具备AIDC一体化工程建设与预制化模块交付运营两大核心技术能力，构建覆盖规划设计、工程建设、模块预制、现场交付及 智能运维的全链路技术体系。`,

      AIDCSolutions: '全栈方案 、资源保障 、高能效与高可靠',
      AIDCSolutions_text: `1.从规划设计、建设交 付到运营的超大型 AIDC全栈定制方案。2.成熟工程团队和技术服务 完善的资源保障工程项目 高效建设与交付。3.先进节能架构PUE<1.25, 7X24小时高效响应 SLA>99.99%`,

      Delivery: `工业级协同设计 、自有工厂预制生产 、极速部署交付`,
      Delivery_text: `1.BIM、Solidworks等工业 级平台 AIDC模块一体化设计。2.智能工厂自动化产线 标准化模块高效预制 生产。3.模块预制与现场工程并行 较传统交付周期缩短 40%+`,
    },
  },

  data_card: {
    title: 'AIDC数据中心定制,数字新基建龙头企业',
    title_sub:
      '为客户提供业界领先的数据中心、智算中心（AIDC）,助力企业业务快速增长',
    city: {
      name: '城市',
      text: '京津冀、长三角、粤港澳等区域构建规模化的数据中心产业集群',
    },
    datacetre: {
      name: '数据中心',
      text: `不断扩张的数据中心资源，提供更利于企业创新发展的互联网基础设施服务`,
    },
    memory: {
      name: '端口容量',
      text: `与电信运营商、互联网内容提供商、云服务提供商建立高速网络连接`,
    },
    capacity: {
      name: '基地型容量',
      text: `可靠的IDC服务，不断增长的高电算力部署，推动企业业务高质量增长`,
    },
    cabinet: {
      name: '城市型机柜',
      text: `稳固、庞大、全连接数字化核心底座`,
    },
  },

  data_card2: {
    title: '专注AI数据中心、变电站、电网接入、储能（BESS）及新能源基础设施建设',
    title_sub:
      '聚焦新能源基础设施建设，实现源网荷储一体化协同，为超算、数据中心提供高可靠、低成本的绿色基础设施整体解决方案',
    city: {
      name: '储能（BESS）',
      text: `全站一键配置，一键交付巡检，30 分钟完成 GWh 电站配置`,
    },
    datacetre: {
      name: '变压器',
      text: `供电稳定可靠、损耗低、能效高。保障变电站、数据中心、储能场站连续供电`,
    },
    memory: {
      name: '储能电站',
      text: `储能电站可实现削峰填谷，平抑新能源发电波动，具备快速调频调压能力`,
    },
    capacity: {
      name: '充电设备',
      text: `智能运维管理，支持云端监控、计费结算、故障告警，便于规模化组网运营`,
    },
  },

  bess_info: {
    title: `储能 BESS`,
    text: `储能 BESS 系统具备削峰填谷能力，实现峰谷套利，有效平抑光伏、风电等新能源出力波动。可快速开展调频调压，故障场景下充当应急备用电源，保障 AI 数据中心、变电站、新能源场站供电连续性。采用模块化设计，支持灵活扩容，适配 GWh 级大型储能电站。搭载全站一键配置功能，30 分钟完成电站配置，简化交付巡检流程。联动变压器、电网接入、充电桩设施，推动源网荷储一体化协同运行，提升电网稳定性，降低场站用电与运维综合成本，助力绿色新能源基础设施项目高效落地。`,

    title_sub01: {
      title: `智高收益`,
      text_01: `12.5 MW / 50 MWh Block 设计，GWh 电站占地面积节省 30 %`,
      text_02: `全系统顶部散热，全液冷 AI 智能控温，辅助功耗降低 14.5 % Powerbidder`,
      text_03: `辅助电力交易，提升场站收益；全液冷 SiC PCS 最大效率 99.3 %`,
      text_04: `精准簇级管理，提升系统发电量 8 %`,
    },
    title_sub02: {
      title: `智能运维`,
      text_01: `全站一键配置，一键交付巡检，30 分钟完成 GWh 电站配置`,
      text_02: `设备本体智能化，部署可支持 30+ 主动预警，故障根因分析定位准确率 ≥ 99 %`,
      text_03: `SOC 自动均衡，无需人工标定`,
    },

    title_sub03: {
      title: `安全可靠`,
      text_01: `电芯热电分区，热失控不蔓延；PCS 液电分离，运行更安全`,
      text_02: `全链多重电气保护，AI 拉弧检测 0 误报`,
      text_03: `AI 电芯健康诊断，热失控预警准确度 ≥ 99 %`,
    },

    title_sub04: {
      title: `电网友好`,
      text_01: `90ms 站级响应，支撑快速调频调压`,
      text_02: `SCR1-40 宽电网强度适应，谐波＜ 1 %`,
      text_03: `具备高低穿、惯量支撑、微秒级电压构建、黑启动等构网功能`,
    },

    typelist: {
      text0: {
        title: '直流侧参数',
        title1: '电芯类型',
        title2: '系统配置',
        title3: '电池容量',
        title4: '电池电压范围',
      },
      text01: {
        title: '变压器参数',
        title1: '变压器类型',
        title2: '额定容量',
        title3: '电压变比',
        title4: '组别',
        text: '干变 / 油变',
      },
    },
  },

  transformer: {
    name: `干式变压器/油浸式变压器`,
    title: '干式变压器',
    title1: '油浸式变压器',
    text: `变压器:主要使用领域：电厂、电站、工矿企业、用户配电站。环氧树脂浇注干式变压器，产品安全性能突出，无漏油起火隐患，适配储能舱室内安装场景。设备结构紧凑，有效节约场地占用空间，适配海外项目地块规划需求。产品运维简单，日常维护工作量小，可适应潮湿、多粉尘等复杂工况环境，运行稳定性强。设备拥有完整 CE 认证，满足欧洲电力标准规范，具备良好过载能力，可适配储能系统频繁充放电带来的负荷波动。产品技术成熟可靠，可匹配项目 37kV/0.69kV 变比、Dy11 组别配置，保障储能系统长期稳定可靠运行。`,
    dry: {
      info: [
        '安全防火，无漏油风险',
        '室内/舱内可安装，占地小',
        '维护工作量低',
        '抗潮湿、抗粉尘，环境适应性强',
        '具备CE认证，满足欧洲项目标准',
        '过载能力优良',
      ],
    },
    oil: {
      info: ['单位造价更低', '适合超大容量户外场景', '散热性能优秀'],
    },
  },

  chargingEquipment: {
    name: `充电设备`,
    title: '分体式充电桩 / 一体式充电桩',

    text: `充电设备可广泛适配多类应用场景，面向新能源场站、AI 数据中心园区、工商业厂区、大型商业综合体、公共交通枢纽及户外园区提供充电服务。既满足公务车辆、物流营运车队集中补能需求，也可服务社会私家车对外开放运营。设备可与储能电站、变压器、电网接入系统协同联动，实现源网荷储一体化调度，有效平抑充电负荷冲击，缓解电网峰期压力。支持规模化组网部署，兼顾快充、慢充不同功率需求，适配海外项目与国内项目建设，兼具自用运维与商业计费运营双重模式，助力绿色基建落地`,
    dry: {
      info: [
        '秒速充电，时刻在线',
        '峰值效率最高可达97.2%，双枪最大电流2400A',
        '全矩阵智能动态功率分配，功率利用最大化',
        '支持铝线缆接入，降低建站成本',
        '具备CE认证，满足欧洲项目标准',
        '整机IP55防护，适用各种严苛环境',
      ],
    },
    title1: '交流桩',
    oil: {
      info: [
        '有序充电，功率智能调节',
        '安全可靠：IP65防护等级，防UV设计，适应各种恶劣环境',
        '耐用节能：超长使用寿命，待机功耗低至5w',
      ],
    },
  },

  powerStation: {
    name: `储能电站`,
    title: '储能电站作为新型电力系统的重要组成部分，具有多方面的显著优势。',

    text: `高效发电站立足绿色低碳建设理念，融合先进发电设备与智能管控系统，实现发电效能最大化。可适配光伏、风电等新能源发电场景，优化能量转换效率，降低发电损耗。配套完善变压、并网装置，稳定输出电能，适配数据中心、储能场站等负荷侧用电需求。
搭载智能监测平台，实时采集设备运行数据，自动完成工况调节、故障预警，减少人工运维投入。可与储能、充电设备联动，构建源网荷储一体化体系，平抑发电出力波动，提升电能消纳能力。项目兼顾安全性与经济性，设备防护等级高，可适应户外复杂工况，助力新型电力基础设施规模化落地。`,
    dry: {
      info: [
        '一是调峰填谷，提升电网稳定性。',
        '二是提高可再生能源的利用效率。',
        '三是响应速度快、灵活性强。',
        '四是经济效益突出',
      ],
    },
    title1: '绿色节能赋能',
    oil: {
      info: ['绿色节能・高效发电', '绿色赋能，节能增效', '节能低碳，智慧发电'],
    },
  },
};
